<template>
  <v-row v-if="connection.credential">
    <v-col cols="4">
        <select-certificate
            v-if="$permissions.canModifyCertificate"
            :dataProviderId="dataProviderId"
            v-model="connection.credential.certificateId"
            :readonly="readonly"/>
    </v-col>
  </v-row>
</template>
<script lang="ts">
import tooltip from "@/components/tooltip.vue";
import createCertificateDialog from "@/views/certificates/create-edit-certificate.vue";
import selectCertificate from "@/views/certificates/select-or-upload-certificate.vue";
import { ConnectionDto, CredentialBaseDto } from "@/datahub-api";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    tooltip,
    createCertificateDialog,
    selectCertificate
  },
})
export default class CertificateComponent extends Vue {
  @Prop() dataProviderId: string;
  @Prop() readonly: boolean;
  @Prop() connection: ConnectionDto & { credential: CredentialBaseDto & { certificateID: string } };

}
</script>
